import React, { useState } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
import ChiTietHopDong from "service/chiTietHopDongApi";
import { pushNotification } from "utils/notifications";
import BtnInChiTiet from "./ChucNang/BtnInChiTiet";

const DanhSachTatToanTableRows = ({
  listUserName,
  list,
  pageIndex,
  pageSize,
  RoleDaDoc,
  RoleXoaHopDongTheoCauHinh,
  RoleInPhieu,
  handleChangeIsReaded,
  handleCheckDelete,
  ChiTietHopDongClick,
  selectedIds,
}) => {
  return list.map((item, index) => {
    return (
      <>
        <div
          className="custom-table-row"
          key={item.ThuChiID || index}
          style={{ minHeight: "40px" }}
        >
          {RoleDaDoc && (
            <div className="custom-table-cell flex-basis-5 flex-basis-5-sm">
              <span className="mobile-column-name color7-bold">Đã đọc</span>
              <div className="center-wrapper">
                <p className="text-center ">
                  <input
                    type="checkbox"
                    checked={item.IsReaded === 1 || item.IsReaded === true}
                    onChange={(e) =>
                      handleChangeIsReaded(item, e.target.checked ? 1 : 0)
                    }
                  />
                </p>
              </div>
            </div>
          )}
          {RoleXoaHopDongTheoCauHinh && (
            <div className="custom-table-cell flex-basis-5 flex-basis-5-sm">
              <span className="mobile-column-name color7-bold">Xóa</span>
              <div className="center-wrapper">
                <p className="text-center ">
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(item.ThuChiID)}
                    onChange={(e) => handleCheckDelete(item, e.target.checked)}
                  />
                </p>
              </div>
            </div>
          )}
          <div className="custom-table-cell flex-basis-5 flex-basis-5-sm disk-mobile">
            <span className="mobile-column-name color7-bold">STT</span>
            <div className="center-wrapper">
              <p className="text-center color7">
                {(pageIndex - 1) * pageSize + index + 1}
              </p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-10-sm">
            <span className="mobile-column-name color7-bold">
              Ngày giao dịch
            </span>
            <div className="center-wrapper">{getDate(item.Time)}</div>
          </div>
          <div className="custom-table-cell  flex-basis-10 flex-basis-10-sm">
            <span className="mobile-column-name color7-bold">Nhân viên</span>
            <div className="center-wrapper">{item.Name}</div>
          </div>
          <div className="custom-table-cell  flex-basis-10 flex-basis-10-sm">
            <span className="mobile-column-name color7-bold">
              Tên khách hàng
            </span>
            <div className="center-wrapper">
              <p>{item.nameCus}</p>
              <a
                href="#"
                className="blue btn-link"
                onClick={() => ChiTietHopDongClick(item)}
              >
                {item.Code}
              </a>
              <br />
              {item.Phone}
            </div>
          </div>
          <div className="custom-table-cell  flex-basis-13 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">Số tiền vay</span>
            <div
              className="center-wrapper color-do-bold"
              style={{ textAlign: "right" }}
            >
              {formatNumber(Math.round(item.Sotienvay))}
            </div>
          </div>
          <div
            className="custom-table-cell  flex-basis-15 flex-basis-15-sm"
            style={{ textAlign: "right" }}
          >
            <span className="mobile-column-name color7-bold">
              Số tiền phải tất toán
            </span>
            <div className="center-wrapper color-do-bold">
              {formatNumber(Math.round(item.TienPhaiTatToan))}
            </div>
          </div>
          <div
            className="custom-table-cell  flex-basis-14 flex-basis-14-sm"
            style={{ textAlign: "right" }}
          >
            <span className="mobile-column-name color7-bold">
              Số tiền đã tất toán
            </span>
            <div className="center-wrapper color-do-bold">
              {formatNumber(Math.round(item.TongTien))}
            </div>
          </div>
          <div
            className="custom-table-cell  flex-basis-13 flex-basis-13-sm"
            style={{ textAlign: "right" }}
          >
            <span className="mobile-column-name color7-bold">Chênh lệch</span>
            <div className="center-wrapper color-do-bold">
              {formatNumber(Math.round(item.ChenhLech))}
            </div>
          </div>
          {RoleInPhieu && (
            <div className="custom-table-cell  flex-basis-5 flex-basis-5-sm">
              <span className="mobile-column-name color7-bold">In Phiếu</span>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  gap: "15px",
                  paddingLeft: "10px",
                }}
              >
                <BtnInChiTiet item={item} />
              </div>
            </div>
          )}
        </div>
      </>
    );
  });
};
const DanhSachTatToanTable = ({
  listUserName,
  list,
  pageIndex,
  pageSize,
  Total,
  TotalSoTienVay,
  TotalSoTienPhaiTatToan,
  TotalSoTienDaTatToan,
  TotalChenhLech,
  RoleDaDoc,
  RoleXoaHopDongTheoCauHinh,
  RoleInPhieu,
  handleChangeIsReaded,
  handleCheckDelete,
  handleCheckAll,
  selectedIds,
}) => {
  const [showChiTietHopDong, setShowChiTietHopDong] = useState(false);
  const objChiTietHopDong = {};
  const [chovayChiTiet, setChoVay] = useState(objChiTietHopDong);
  const ChiTietHopDongClick = (item) => {
    ChiTietHopDong.getChiTietHopDong1(item.ChoVayID).then((response) => {
      setChoVay(response.data);
      setShowChiTietHopDong(true);
    });
  };
  if (!list || list.length === 0) {
    return (
      <div className="custom-table-row">
        <div
          className="custom-table-cell text-center red"
          style={{ width: "100%" }}
        >
          Không có dữ liệu
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="Left808x200 Table-main-new css-table-ds">
        <div className="table-mobile table-mobile-hover">
          <div className="custom-table-wrapper">
            <div className="table-headers">
              {RoleDaDoc && (
                <div className="custom-table-header flex-basis-5 flex-basis-5-sm text-center">
                  <p>Đã đọc</p>
                </div>
              )}
              {RoleXoaHopDongTheoCauHinh && (
                <div className="custom-table-header flex-basis-5 flex-basis-5-sm text-center">
                  <p>Xóa</p>
                  <input
                    type="checkbox"
                    checked={
                      list.length > 0 && selectedIds.length === list.length
                    }
                    onChange={(e) => handleCheckAll(e.target.checked ? 1 : 0)}
                  />
                </div>
              )}
              <div className="custom-table-header flex-basis-5 flex-basis-5-sm text-center">
                <p className="">
                  STT
                  <br />
                  <span className="color-do-bold">[{Total ? Total : 0}]</span>
                </p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                <p>Ngày giao dịch</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                <p>Nhân viên</p>
              </div>
              <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                <p>Tên khách hàng</p>
              </div>
              <div
                className="custom-table-header flex-basis-13 flex-basis-13-sm"
                style={{ textAlign: "right" }}
              >
                <p>
                  Số tiền vay
                  <br />
                  <span className="color-do-bold">
                    $ ={" "}
                    {TotalSoTienVay
                      ? formatNumber(Math.round(TotalSoTienVay))
                      : 0}
                  </span>
                </p>
              </div>
              <div
                className="custom-table-header flex-basis-15 flex-basis-15-sm"
                style={{ textAlign: "right" }}
              >
                <p>
                  Số tiền phải tất toán
                  <br />
                  <span className="color-do-bold">
                    $ ={" "}
                    {TotalSoTienPhaiTatToan
                      ? formatNumber(Math.round(TotalSoTienPhaiTatToan))
                      : 0}
                  </span>
                </p>
              </div>
              <div
                className="custom-table-header flex-basis-14 flex-basis-14-sm"
                style={{ textAlign: "right" }}
              >
                <p>
                  Số tiền đã tất toán
                  <br />
                  <span className="color-do-bold">
                    $ ={" "}
                    {TotalSoTienDaTatToan
                      ? formatNumber(Math.round(TotalSoTienDaTatToan))
                      : 0}
                  </span>
                </p>
              </div>
              <div
                className="custom-table-header flex-basis-13 flex-basis-13-sm"
                style={{ textAlign: "right" }}
              >
                <p>
                  Chênh lệch
                  <br />
                  <span className="color-do-bold">
                    $ ={" "}
                    {TotalChenhLech
                      ? formatNumber(Math.round(TotalChenhLech))
                      : 0}
                  </span>
                </p>
              </div>
              {RoleInPhieu && (
                <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                  <p>In Phiếu</p>
                </div>
              )}
            </div>
            <div className="custom-table-body">
              <DanhSachTatToanTableRows
                listUserName={listUserName}
                list={list}
                pageIndex={pageIndex}
                pageSize={pageSize}
                RoleDaDoc={RoleDaDoc}
                RoleXoaHopDongTheoCauHinh={RoleXoaHopDongTheoCauHinh}
                RoleInPhieu={RoleInPhieu}
                handleChangeIsReaded={handleChangeIsReaded}
                handleCheckDelete={handleCheckDelete}
                selectedIds={selectedIds}
                ChiTietHopDongClick={ChiTietHopDongClick}
              />
              {showChiTietHopDong && (
                <ChiTietHopDongContainer
                  show={() => setShowChiTietHopDong(true)}
                  onHide={() => setShowChiTietHopDong(false)}
                  data={chovayChiTiet}
                  setModalTaiSan={() => setShowChiTietHopDong(true)}
                ></ChiTietHopDongContainer>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DanhSachTatToanTable;
